module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "generalSettingsScreen": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("General")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Documents")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("PDF's")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Attachments Categories")]), _vm._v(" "), _c('v-tab', {
    key: 6,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('v-tab', {
    key: 7,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("SO Template")]), _vm._v(" "), _c('v-tab', {
    key: 8,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("PO Template")]), _vm._v(" "), _c('v-tab', {
    key: 9,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Quote Template")]), _vm._v(" "), _c('v-tab', {
    key: 10,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Lookup Config")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Document Numbering")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.document_numbering_items,
      "label": "Document Numbering",
      "item-value": "id",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.userDocSetting),
      callback: function($$v) {
        _vm.userDocSetting = $$v
      },
      expression: "userDocSetting"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Quote No. Prefix")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Quote No. Prefix",
      "solo": ""
    },
    model: {
      value: (_vm.userQuotePrefix),
      callback: function($$v) {
        _vm.userQuotePrefix = $$v
      },
      expression: "userQuotePrefix"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Order No. Prefix")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Order No. Prefix",
      "solo": ""
    },
    model: {
      value: (_vm.userOrderPrefix),
      callback: function($$v) {
        _vm.userOrderPrefix = $$v
      },
      expression: "userOrderPrefix"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Quote Expiry Date")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "input-1",
      "label": "Quote Expiry (days)",
      "solo": ""
    },
    model: {
      value: (_vm.userQuoteExpiry),
      callback: function($$v) {
        _vm.userQuoteExpiry = $$v
      },
      expression: "userQuoteExpiry"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Default Customer Type")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.default_customer_type,
      "label": "Default Customer Type",
      "item-value": "id",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.defaultUserType),
      callback: function($$v) {
        _vm.defaultUserType = $$v
      },
      expression: "defaultUserType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installation Calculator"
    },
    model: {
      value: (_vm.installationActive),
      callback: function($$v) {
        _vm.installationActive = $$v
      },
      expression: "installationActive"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Can Create Quote For Company"
    },
    model: {
      value: (_vm.companyQuote),
      callback: function($$v) {
        _vm.companyQuote = $$v
      },
      expression: "companyQuote"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Branches Active"
    },
    model: {
      value: (_vm.branchActive),
      callback: function($$v) {
        _vm.branchActive = $$v
      },
      expression: "branchActive"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Department Active"
    },
    model: {
      value: (_vm.departmentActive),
      callback: function($$v) {
        _vm.departmentActive = $$v
      },
      expression: "departmentActive"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "All Departments Share Statuses"
    },
    model: {
      value: (_vm.departmentStatusShare),
      callback: function($$v) {
        _vm.departmentStatusShare = $$v
      },
      expression: "departmentStatusShare"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Has Stock Levels"
    },
    model: {
      value: (_vm.hasStock),
      callback: function($$v) {
        _vm.hasStock = $$v
      },
      expression: "hasStock"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Quote Status Denominator")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.quote_status_change_order,
      "label": "Quote Status Denominator",
      "item-value": "id",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.quoteStatusRankOrder),
      callback: function($$v) {
        _vm.quoteStatusRankOrder = $$v
      },
      expression: "quoteStatusRankOrder"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Allowed File Type")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Allowed File Types",
      "solo": ""
    },
    model: {
      value: (_vm.userAllowedFileTypes),
      callback: function($$v) {
        _vm.userAllowedFileTypes = $$v
      },
      expression: "userAllowedFileTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Maximum File Upload Size ( in MB )")]), _vm._v(" "), _c('span', {
    staticClass: "hints"
  }, [_vm._v(" ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Allowed File Types",
      "solo": ""
    },
    model: {
      value: (_vm.maxFileUpload),
      callback: function($$v) {
        _vm.maxFileUpload = $$v
      },
      expression: "maxFileUpload"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Manufacturer Installer Name")]), _vm._v(" "), _c('span', {
    staticClass: "hints"
  }, [_vm._v(" ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Manufacturer Installer Name",
      "solo": ""
    },
    model: {
      value: (_vm.installerName),
      callback: function($$v) {
        _vm.installerName = $$v
      },
      expression: "installerName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Hide Ecommerce Section"
    },
    model: {
      value: (_vm.hideEcommerce),
      callback: function($$v) {
        _vm.hideEcommerce = $$v
      },
      expression: "hideEcommerce"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Hide Trailing Zeros"
    },
    model: {
      value: (_vm.hideTrailingZeros),
      callback: function($$v) {
        _vm.hideTrailingZeros = $$v
      },
      expression: "hideTrailingZeros"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Hide Vendors For Edit Screen"
    },
    model: {
      value: (_vm.hideVendors),
      callback: function($$v) {
        _vm.hideVendors = $$v
      },
      expression: "hideVendors"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "PDF - Including VAT Totals"
    },
    model: {
      value: (_vm.vatIncluding),
      callback: function($$v) {
        _vm.vatIncluding = $$v
      },
      expression: "vatIncluding"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Manufacturer Users")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.userManufacturerDoc),
      callback: function($$v) {
        _vm.userManufacturerDoc = $$v
      },
      expression: "userManufacturerDoc"
    }
  }, [_c('v-radio', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "label": "Estimate",
      "value": "Estimate"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Quote",
      "value": "Quote"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Users")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.userCustomerDoc),
      callback: function($$v) {
        _vm.userCustomerDoc = $$v
      },
      expression: "userCustomerDoc"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Estimate",
      "value": "Estimate"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Quote",
      "value": "Quote"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Specific Users")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.userSpecificDoc),
      callback: function($$v) {
        _vm.userSpecificDoc = $$v
      },
      expression: "userSpecificDoc"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Estimate",
      "value": "Estimate"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Quote",
      "value": "Quote"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Public Users")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.userPublicDoc),
      callback: function($$v) {
        _vm.userPublicDoc = $$v
      },
      expression: "userPublicDoc"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Estimate",
      "value": "Estimate"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Quote",
      "value": "Quote"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Header Title Size")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.header_title_items,
      "label": "Header Title Size",
      "item-value": "id",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.userPdfFontsize),
      callback: function($$v) {
        _vm.userPdfFontsize = $$v
      },
      expression: "userPdfFontsize"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Page Orientation")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.page_orientation_items,
      "label": "Page Orientation",
      "item-value": "id",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.userPageOrientation),
      callback: function($$v) {
        _vm.userPageOrientation = $$v
      },
      expression: "userPageOrientation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show Client Logo In Notification"
    },
    model: {
      value: (_vm.showClientLogoNotification),
      callback: function($$v) {
        _vm.showClientLogoNotification = $$v
      },
      expression: "showClientLogoNotification"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Page Numbers"
    },
    model: {
      value: (_vm.userPageNumbers),
      callback: function($$v) {
        _vm.userPageNumbers = $$v
      },
      expression: "userPageNumbers"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show Quote Details in SO Document"
    },
    model: {
      value: (_vm.docShowSoQuoteDetails),
      callback: function($$v) {
        _vm.docShowSoQuoteDetails = $$v
      },
      expression: "docShowSoQuoteDetails"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show Quote Details in PO Document"
    },
    model: {
      value: (_vm.docShowQuoteDetails),
      callback: function($$v) {
        _vm.docShowQuoteDetails = $$v
      },
      expression: "docShowQuoteDetails"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show Customer Details in Document"
    },
    model: {
      value: (_vm.docShowCustomerDetails),
      callback: function($$v) {
        _vm.docShowCustomerDetails = $$v
      },
      expression: "docShowCustomerDetails"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show Customer Delivery Details in Document"
    },
    model: {
      value: (_vm.docShowDeliveryDetails),
      callback: function($$v) {
        _vm.docShowDeliveryDetails = $$v
      },
      expression: "docShowDeliveryDetails"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Manufacturer Address")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.manufacturerAddress),
      callback: function($$v) {
        _vm.manufacturerAddress = $$v
      },
      expression: "manufacturerAddress"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Include Standard terms"
    },
    model: {
      value: (_vm.userStandardTerms),
      callback: function($$v) {
        _vm.userStandardTerms = $$v
      },
      expression: "userStandardTerms"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Buy More Link")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Buy More Link",
      "solo": ""
    },
    model: {
      value: (_vm.buyMoreLink),
      callback: function($$v) {
        _vm.buyMoreLink = $$v
      },
      expression: "buyMoreLink"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Terms and Conditions Link")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Terms and Conditions Link",
      "solo": ""
    },
    model: {
      value: (_vm.termsLink),
      callback: function($$v) {
        _vm.termsLink = $$v
      },
      expression: "termsLink"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('Vueditor', {
    ref: "utText",
    model: {
      value: (_vm.userTermsText),
      callback: function($$v) {
        _vm.userTermsText = $$v
      },
      expression: "userTermsText"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.catAdd == true) ? _c('v-flex', {
    attrs: {
      "lg10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Category Name",
      "solo": ""
    },
    model: {
      value: (_vm.catAddInput),
      callback: function($$v) {
        _vm.catAddInput = $$v
      },
      expression: "catAddInput"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.catAdd == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "top": "-5px",
      "right": "10px !important"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCancelAddCat()
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e(), _vm._v(" "), (_vm.catAdd == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "top": "-5px"
    },
    attrs: {
      "disabled": _vm.catAddInput == '',
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddCat()
      }
    }
  }, [_vm._v("Add")])], 1) : _vm._e(), _vm._v(" "), (_vm.catEdit == true) ? _c('v-flex', {
    attrs: {
      "lg10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Category Name",
      "solo": ""
    },
    model: {
      value: (_vm.catEditInput.name),
      callback: function($$v) {
        _vm.$set(_vm.catEditInput, "name", $$v)
      },
      expression: "catEditInput.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.catEdit == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "top": "-5px",
      "right": "10px !important"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCancelAddCat()
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e(), _vm._v(" "), (_vm.catEdit == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "top": "-5px"
    },
    attrs: {
      "disabled": _vm.catEditInput == '',
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateCat()
      }
    }
  }, [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), (_vm.catAdd == false && _vm.catEdit == false) ? _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px !important",
      "margin-bottom": "0px !important"
    },
    attrs: {
      "lg6": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncShowAddCat()
      }
    }
  }, [_vm._v("Add")])], 1) : _vm._e(), _vm._v(" "), (_vm.catAdd == false && _vm.catEdit == false) ? _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.catAdd == false && _vm.catEdit == false) ? _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('small', [_vm._v("Update POD Document Category")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.attachmentCategories,
      "label": "Update POD Uploaded Category",
      "item-value": "id",
      "item-text": "name",
      "item-": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncUpdatePodCategory
    },
    model: {
      value: (_vm.podCategory),
      callback: function($$v) {
        _vm.podCategory = $$v
      },
      expression: "podCategory"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.catAdd == false && _vm.catEdit == false) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1 smallBody",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.attachmentCategories,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "80%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (props.item.id == 0) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v("-")]) : _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncShowEditCategory(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]), _vm._v(" "), (props.item.id == 0) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v("-")]) : _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteCategory(props.item.id, props.item.catCount)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])])])]
      }
    }], null, false, 372424954)
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 6,
    staticClass: "pl-4 pr-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Collection")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Customer can collect"
    },
    model: {
      value: (_vm.customerCanCollect),
      callback: function($$v) {
        _vm.customerCanCollect = $$v
      },
      expression: "customerCanCollect"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Collection Alias")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Collection Alias",
      "solo": ""
    },
    model: {
      value: (_vm.collectionLabel),
      callback: function($$v) {
        _vm.collectionLabel = $$v
      },
      expression: "collectionLabel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Delivery")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Products can be delivered"
    },
    model: {
      value: (_vm.productsCanBeDelivered),
      callback: function($$v) {
        _vm.productsCanBeDelivered = $$v
      },
      expression: "productsCanBeDelivered"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Delivery Alias")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Delivery Alias",
      "solo": ""
    },
    model: {
      value: (_vm.deliveryLabel),
      callback: function($$v) {
        _vm.deliveryLabel = $$v
      },
      expression: "deliveryLabel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Delivery Options")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.delivery_options,
      "label": "Delivery Options",
      "item-value": "id",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.deliveryOptions),
      callback: function($$v) {
        _vm.deliveryOptions = $$v
      },
      expression: "deliveryOptions"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 7,
    staticClass: "pl-4 pr-4"
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncPrintTest(_vm.soTemplate)
      }
    }
  }, [_vm._v("PRINT TEST")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Sales Order Template",
      "rows": "18",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.soTemplate),
      callback: function($$v) {
        _vm.soTemplate = $$v
      },
      expression: "soTemplate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 8,
    staticClass: "pl-4 pr-4"
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncPrintTest(_vm.poTemplate)
      }
    }
  }, [_vm._v("PRINT TEST")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Purchase Order Template",
      "rows": "18",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.poTemplate),
      callback: function($$v) {
        _vm.poTemplate = $$v
      },
      expression: "poTemplate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 9,
    staticClass: "pl-4 pr-4 quoteTemplate"
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncPrintTest(_vm.quoteTemplate)
      }
    }
  }, [_vm._v("PRINT TEST")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Quote Document Template",
      "rows": "18",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.quoteTemplate),
      callback: function($$v) {
        _vm.quoteTemplate = $$v
      },
      expression: "quoteTemplate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 10,
    staticClass: "pl-4 pr-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Client Domain")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Client Domain",
      "solo": ""
    },
    model: {
      value: (_vm.lookupClientDomain),
      callback: function($$v) {
        _vm.lookupClientDomain = $$v
      },
      expression: "lookupClientDomain"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Client ID",
      "solo": ""
    },
    model: {
      value: (_vm.lookupClientId),
      callback: function($$v) {
        _vm.lookupClientId = $$v
      },
      expression: "lookupClientId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Client Secret")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Client Secret",
      "solo": ""
    },
    model: {
      value: (_vm.lookupClientSecret),
      callback: function($$v) {
        _vm.lookupClientSecret = $$v
      },
      expression: "lookupClientSecret"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Client User")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Client User",
      "solo": ""
    },
    model: {
      value: (_vm.lookupClientUser),
      callback: function($$v) {
        _vm.lookupClientUser = $$v
      },
      expression: "lookupClientUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Client Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Client Password",
      "solo": ""
    },
    model: {
      value: (_vm.lookupClientPassword),
      callback: function($$v) {
        _vm.lookupClientPassword = $$v
      },
      expression: "lookupClientPassword"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.userEditSettings) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.userEditSettings) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateSettings.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_c('strong', [_vm._v(" ")])])])], 1)], 1)
},staticRenderFns: []}